import * as yup from 'yup';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import { t } from 'react-switch-lang';
export const DepartmentScheme = yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validNameandNumberEngMneRegex, t('message.fieldNotValid'))
      .max(100, `${t('message.max', {max: 100})}`)
      .min(3, `${t('message.min', {min: 3})}`),
  nameEn: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
    .matches(validNameandNumberEngMneRegex, t('message.fieldNotValid'))
    .max(100, `${t('message.max', {max: 100})}`)
    .min(3, `${t('message.min', {min: 3})}`),
  departmentTypeId: yup
      .object()
      .nullable()
      .required(t('message.fieldRequired')),
  sectorDirectorId: yup
      .object()
      .nullable()
      .required(t('message.fieldRequired')),
  });